export enum TranslationsServiceErrorCodes {
  GENERIC,
  CANNOT_LOAD_FILE,
  CANNOT_PARSE_JSON,
}
